// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lusrqlpxylyhwuxcttzj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx1c3JxbHB4eWx5aHd1eGN0dHpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQxOTMxMTUsImV4cCI6MjA4OTc2OTExNX0.EtqYvAz75gZGFZMgGzcgsF7Sn9IjsbGnRqXAcFr1vGI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    worker: true,
    heartbeatIntervalMs: 15000,
  },
});

void supabase.auth.getSession().then(({ data: { session } }) => {
  void supabase.realtime.setAuth(session?.access_token ?? undefined);
});

supabase.auth.onAuthStateChange((_event, session) => {
  void supabase.realtime.setAuth(session?.access_token ?? undefined);
});